import {
  getRemoteProfile,
  listRemoteEvents,
  loadMoreMyRemoteEvents,
  listRemoteProfiles,
} from "../core/api/karangoApi";

export async function loadEventsRuntimeData({ signal, lat, lng, radiusKm, onPage, view, sort } = {}) {
  return {
    // Nearest doit examiner toutes les coordonnées éligibles côté serveur.
    // Une page de 50 suffit à l'écran et évite de répéter ce classement global
    // quatre fois pour remplir le plafond générique de 200 éléments.
    events: await listRemoteEvents({
      ...(sort === "nearest" ? { limit: 50 } : {}),
      signal,
      lat,
      lng,
      radiusKm,
      onPage,
      view,
      sort,
    }),
    source: "api",
  };
}

// Historique personnel (Agenda) : 1ere page des sorties organisees/rejointes,
// toutes dates confondues — distinct du flux de decouverte actif (cf. C21 de
// l'audit). Renvoie `nextCursor` pour permettre un "charger plus" explicite
// au lieu d'un plafond silencieux (cf. section 21/22 du contre-audit).
export async function loadMyEventsRuntimeData({ signal } = {}) {
  const page = await loadMoreMyRemoteEvents({ signal });
  return {
    events: page.events,
    nextCursor: page.nextCursor,
    source: "api",
  };
}

export async function loadMoreMyEventsRuntimeData({ cursor, signal } = {}) {
  const page = await loadMoreMyRemoteEvents({ cursor, signal });
  return {
    events: page.events,
    nextCursor: page.nextCursor,
    source: "api",
  };
}

export async function loadSecretEventsRuntimeData({ signal } = {}) {
  return {
    events: await listRemoteEvents({ signal, scope: "secret" }),
    source: "api",
  };
}

export async function loadProfilesRuntimeData({ signal } = {}) {
  return {
    profiles: await listRemoteProfiles({ signal }),
    registrations: [],
    source: "api",
  };
}

export async function loadPublicProfileRuntimeData(userId, { signal } = {}) {
  if (!userId) {
    return null;
  }

  return getRemoteProfile(userId, { signal });
}
